import { React, useState } from "react";

import styles from "./Navbar.module.scss";
import { AiOutlineClose } from "react-icons/ai";
import Link from "next/link";
import Slide from "react-reveal/Slide";
import Image from "next/image";
import Backdrop from "./BackDrop";

const SideBar = () => {
  const [show, setShow] = useState(false);

  return (
    <>
      {show && <Backdrop />}

      <Slide left when={show} duration={300}>
        <div className={styles.sideBar}>
          <div className={styles.headerSideBar}>
            <AiOutlineClose
              className={styles.icons}
              onClick={() => setShow(!show)}
            />
            <Link href={'/'}>
              <Image
                src='/assets/Image/Logo.png'
                width={205}
                height={45.25}
                className={styles.image}
                alt='logo'
              />
            </Link>
          </div>

          <div className={styles.list}>
            <ul className={styles.listitem}>
              <li className={styles.item}>
                <Link href={'/'}>Home</Link>
              </li>
              <li className={styles.item}>
                <Link href={'/tokenRewards'}>Token Rewards</Link>
              </li>
              <li className={styles.item}>
                <Link href={'/bloveToken'}>B-Love Token</Link>
              </li>

              <li className={styles.item}>
                <Link href={'/privacy'}>Privacy Policy</Link>
              </li>

              <li className={styles.item}>
                <Link href={'https://ito.blove.network/'}>ITO</Link>
              </li>
            </ul>
            <Link
              target='_blank'
              href={
                'https://play.google.com/store/apps/details?id=biz.innovationfactory.bnetwork&hl=en_US&pli=1'
              }
            >
              <button className={styles.btn}>Downlaod</button>
            </Link>
          </div>
        </div>
      </Slide>
    </>
  )
};

export default SideBar;
